import React from 'react';
import TP01 from './tp01/customerweb';
import TP02 from './tp02/customerweb';
import TP03 from './tp03/customerweb';
import TP04 from './tp04/customerweb';
import TP05 from './tp05/customerweb';
import TP06 from './tp06/customerweb';
import TPRedir from './redirect';
// 20201105 add
// 加入審核機制判斷 
// 審核捍未通過審核將導向舊版的廠商
// 客服須要能正常打開預覽的葉面
class customerIndex extends React.Component{

    constructor(props){
        super(props);
        this.state={theme : '' };
    }
    
    componentDidMount(){
        const cid = this.props.match.params.cid;
        this.props.getDataList(cid);
       
    }
  
    
    chooseTemplate= (themNum,Enabled, themIndex) =>{     
       // console.log('chooseTemplate'+Enabled);
        const preview=this.props.match.path.indexOf('preview');
        const index = themIndex ? themIndex : 0;
        const pageEnable = Enabled >=2 ? Enabled:(preview > 4 ? 1: Enabled);
        if(pageEnable===1){     
                switch(themNum){
                    case "tp01":  return(<TP01 key={index} themeNum={themNum} {...this.props}/>); 
                    case "tp02":  return(<TP02 key={index} themeNum={themNum} {...this.props}/>); 
                    case "tp03":  return(<TP03 key={index} themeNum={themNum} {...this.props}/>);
                    case "tp04":  return(<TP04 key={index} themeNum={themNum} {...this.props}/>);
                    case "tp05":  return(<TP05 key={index} themeNum={themNum} {...this.props}/>);
                    case "tp06":  return(<TP06 key={index} themeNum={themNum} {...this.props}/>);
                    default:  return(<TP01 key={index} {...this.props}/>); 
                }
            }else{
                return(<TPRedir RedirMsg="目前你無法看到該頁面" {...this.props}/>);
        }
    }

    render(){
        const { data, isLoading } = this.props.datatableReducer;
        const themNum = this.props.match.params.themNum;
      
        //console.log('index Type:'+typeof(data)+'  Data:'+data.length +' isLoading:'+isLoading+ ' typeCheack:'+(!isLoading)+ ' themNum:'+themNum);
        return(
            <div>
                {themNum ? this.chooseTemplate(themNum) :
                (!isLoading && data) && data.map( (items,index) =>{
                    //console.log('render-chooseTemplate');
                    return this.chooseTemplate(items.themeNum,items.Enabled, index);
                })}
                
            </div>
        )
    }

}

export default customerIndex;